import type { ToastType } from "../contexts/toast/types";

/**
 * Ref used by QueryClient onError when ToastProvider is not yet in the tree.
 * ToastProvider sets this on mount so query errors can show toasts.
 */
export const globalToastRef: {
  current: ((message: string, type?: ToastType) => string) | null;
} = { current: null };
